module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-col page"
  }, [_c('div', {
    staticClass: "flex-col section_1"
  }, [_c('div', {
    staticStyle: {
      "padding": "0 16px",
      "background": "white",
      "border-bottom": "#E0E0E0 solid 0.5px"
    }
  }, [_c('van-tabs', {
    attrs: {
      "color": "#02d644",
      "line-height": "4px"
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "全部订单"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "待支付"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "进行中"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "已完结"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-col list"
  }, [_vm._l((_vm.orderList), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "flex-col list-item"
    }, [_c('CarCardForOrderListVue', {
      attrs: {
        "carDetails": item
      },
      on: {
        "click": function($event) {
          return _vm.goOrderDetail(item)
        }
      }
    })], 1)
  }), _vm._v(" "), (_vm.orderList.length == 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "200px",
      "color": "#ccc"
    }
  }, [_vm._v("\n            暂无数据\n        ")]) : _vm._e()], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4fe1a574", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4fe1a574","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/saleCar/order/orderList.vue
// module id = 280
// module chunks = 320 321